// extracted by mini-css-extract-plugin
export default {"root":"IconArrowHead_root__sTfhh"};